<template>
  <v-dialog :value="true" persistent max-width="500" scrollable>
    <v-card>
      <v-card-title class="headline">Add Sway Offer</v-card-title>
      <v-card-text style="max-height: 500px">
        <v-form ref="addSwayOfferForm">
          <v-row class="mt-1">
            <v-col cols="12">
              <v-select v-model="offerType" :items="swayOfferTypes" outlined item-text="title" item-value="type" label="Offer Type" />
            </v-col>
          </v-row>
          <v-row class="mt-n4">
            <v-col cols="12">
              <v-text-field v-model="offerSummary" :disabled="addSwayOfferLoading" outlined label="Offer Summary" :rules="requiredRule" />
            </v-col>
          </v-row>

          <template v-if="offerType === 'WEB'">
            <v-row class="mt-n4">
              <v-col cols="12">
                <v-text-field
                  v-model="approveProofEmailTemplateId"
                  :disabled="addSwayOfferLoading"
                  outlined
                  label="Approve Proof Email Template ID"
                  :rules="[emailTemplateIdRule]"
                />
              </v-col>
            </v-row>

            <v-row class="mt-n4">
              <v-col cols="12">
                <v-text-field
                  v-model="denyProofEmailTemplateId"
                  :disabled="addSwayOfferLoading"
                  outlined
                  label="Deny Proof Email Template ID"
                  :rules="[emailTemplateIdRule]"
                />
              </v-col>
            </v-row>
          </template>

          <template v-if="isGiveAwayOffer">
            <v-row class="mt-n4">
              <v-col cols="12">
                <v-text-field
                  v-model="expirationDescription"
                  :disabled="addSwayOfferLoading"
                  outlined
                  label="Expiration text to display"
                  :rules="[emailTemplateIdRule]"
                />
              </v-col>
            </v-row>

            <v-row class="mt-n4">
              <v-col cols="12" class="text-center">
                <ImageUploadForm
                  :edit-mode="true"
                  :allow-image-deletion="true"
                  :image-url="offerImageUrl"
                  image-type="swayOffer"
                  @image-deleted="handleUpdateSwayOfferImage"
                  @image-uploaded="handleUpdateSwayOfferImage"
                >
                  <h1>Offer Image</h1>
                </ImageUploadForm>
              </v-col>
            </v-row>
          </template>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="addSwayOfferLoading" color="darken-1" text @click="() => this.$emit('new-offer-modal-close')">Cancel</v-btn>
        <v-btn :loading="addSwayOfferLoading" color="primary darken-1" text @click="handleAddSwayOfferModalSave()"> Save </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'

import { swayOfferTypes, isGiveAwayOffer } from '@/models/SwayOffer'
import ImageUploadForm from '@/components/ImageUploadForm'

export default Vue.extend({
  name: 'NewSwayOfferModal',

  components: {
    ImageUploadForm,
  },

  data: () => ({
    offerSummary: '',
    offerImageUrl: '',
    offerType: 'LOCAL',
    expirationDescription: '',
    approveProofEmailTemplateId: 'd-86c84138789f4f96ad94a4dbe015d71f',
    denyProofEmailTemplateId: 'd-528f459dc8c548cf9aa9e79660c800ba',
    addSwayOfferLoading: false,
    requiredRule: [(v) => !!v || 'Required'],
  }),

  computed: {
    isGiveAwayOffer() {
      return isGiveAwayOffer(this.offerType)
    },
    swayOfferTypes() {
      return Object.values(swayOfferTypes)
    },
  },

  mounted() {
    this.$store.dispatch('swayoffer/refresh')
  },

  methods: {
    ...mapActions('swayoffer', ['createSwayOffer']),
    emailTemplateIdRule(value) {
      if (this.offerType === 'WEB' && value.length === 0) return 'Required'

      return true
    },
    handleAddSwayOfferModalSave() {
      if (!this.$refs.addSwayOfferForm.validate()) return

      this.createSwayOffer({
        swayOfferBase: {
          offer_type: this.offerType,
          offer_summary: this.offerSummary,
          offer_image_url: this.offerImageUrl,
          expiration_description: this.expirationDescription,
          approve_proof_email_template_id: this.offerType === 'WEB' ? this.approveProofEmailTemplateId : null,
          deny_proof_email_template_id: this.offerType === 'WEB' ? this.denyProofEmailTemplateId : null,
        },
      }).then(() => {
        this.$emit('new-offer-modal-close')
        this.$toast.success('Sway Offer Created!')

        Vue.nextTick(() => {
          this.$vuetify.goTo('#offerlist-ACTIVE')
        })
      })
    },
    handleUpdateSwayOfferImage(uploadResults) {
      this.offerImageUrl = uploadResults.image_url
    },
  },
})
</script>
